import { render, staticRenderFns } from "./sendmoney-philgov-enter-detail.vue?vue&type=template&id=638767ab&"
import script from "./sendmoney-philgov-enter-detail.vue?vue&type=script&lang=js&"
export * from "./sendmoney-philgov-enter-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports